import { Component, OnInit, OnDestroy, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../lib/services/data/data.service';
import { ContextService } from '../../lib/services/context/context.service';
import { LanguageService } from '../../lib/services/lang/language.service';
import { ScrollService } from '../../lib/services/scroll/scroll.service';
import { LoggerService } from '../../lib/services/logger/logger.service';
import { Subscription } from 'rxjs';
import { Logger } from '../../lib/classes/logger';
import { ComponentState } from '../../lib/types/componentState';
import { mergeMap, combineLatest,tap, map } from 'rxjs/operators';
import { Interpretations } from '../../lib/classes/interpretations';
import { FiltersInterpretationService } from '../../lib/services/interpretation-service/filters-interpretation-service.service';
import { TableAbstractComponent } from 'src/app/common-page-components/classes/table-abstract-component';
import { MembersSearchFiltersService } from 'src/app/members/info-page/members-search/services/members-search-filters.service';
import { RulebookInterpretationsStore } from 'src/app/common-page-components/stores/entities-store/rulebook-interpretations';
import { HttpClient } from '@angular/common/http';
import { IHeaderConfig } from 'src/app/common-page-components/headers-component/headers-component.component';

@Component({
  selector: 'app-interpration-page',
  templateUrl: './interpration-page.component.html',
  styleUrls: ['./interpration-page.component.scss']
})
export class InterprationPageComponent extends TableAbstractComponent implements OnInit {

  headers: Array<IHeaderConfig> = [
    { name: 'Effective', isSortable: true, sortProperty: 'EFFECTIVE' },
    //{ name: "Approved", isSortable: true, sortProperty: 'APPROVED' },
    { name: 'Title', isSortable: true, sortProperty: 'TITLE' },
    { name: 'Approved By', isSortable: false, },
    { name: 'Related articles', isSortable: false, },
    { name: "", isSortable:false}, // Download column
    { name: '', isSortable: false, },
  ];

  /**
   * Creates an instance of InterprationPageComponent.
   *
   * @param {Injector} injector
   * @param {HttpClient} http
   * @param {InterprationPageComponent} filters_service
   *   Search filters.
   *
   * @memberof InterprationPageComponent
   */
  constructor(injector: Injector, http: HttpClient, public filters_service: FiltersInterpretationService) {
    super(injector, filters_service, new RulebookInterpretationsStore(http, []));
  }

  /**
   * Implements ngOnInit().
   *
   * @memberof InterprationPageComponent
   */
  ngOnInit(): void {
    this.filters_service.getDataStreamWithFilters().pipe(
      combineLatest([this.reload.asObservable()]), map(([a, b]) => a), map(([order, text, dateFrom, dateTo]) => {

        const params = {
          SortBy: order.sortingSend,
          fText:text.text
        }
        return params;
      }), mergeMap(params => this.model.requestData(params, this.request_more_data)
      )).subscribe();
  }

  /**
   * On click in row element for expand content
   *
   * @param {number} index
   * @memberof InterprationPageComponent
   */
  onClick(index:number){
    this.selectIndex(index);
  }

  /**
   * Method for split title parameters with id
   *
   * @param {Array<any>} element
   * @returns {Array<string>}
   * @memberof InterprationPageComponent
   */
  processParam(element:string) : string{
    return element.split(' ')[0];
  }
}
